module.exports = __webpack_public_path__ + "static/Apercu-Mono-Pro-Light-937ac7cbd16a32d1804949a797532ec3.otf";